<script setup>
import { storage } from '../../storage'
import { galaxies, aliensTypes } from '../../staticData'
import { stringNumber, getCoinUrl, saveToLocaleStorage } from '../../helpers/functions.js'
import { speedGalaxy } from '../../helpers/renderer.js'

import ModalBlock from '../ModalBlock'
import config from '../../set_config.json'

const props = defineProps(['galaxy'])
const emits = defineEmits(['hide-window', 'set-new-audio'])

const isNotEnough = (() => {
    const res = BigInt(props.galaxy.distance) >= storage.COINS;
    console.log('RES', res, props.galaxy.distance, storage.COINS)
    return res
    // return false
})()

const gIndex = galaxies.findIndex(g => g.name === props.galaxy.name)

function getPinkAward() {
    return Math.ceil(5 + (3 * (gIndex - 1)))
}
function getBlackAward() {
    return Math.ceil(1 + (1.5 * (gIndex - 1)))
}
const alienAward = aliensTypes.find(a => a.minGalaxyInd === gIndex)



function upgradeGalaxy() {
    // if (!config.isDev) {
    if (config.isDev || BigInt(props.galaxy.distance) <= storage.COINS) {
        storage.PINK_COINS += getPinkAward()
        storage.BLACK_COINS += getBlackAward()
        for (const key in storage.ALIENS_OWNED) {
            storage.ALIENS_OWNED[key].amount = 0
        }
        storage.COINS = 0n
        // console.log('UPGRADE', storage.COINS)
        saveToLocaleStorage()
        if (storage.GALAXY_IND < galaxies.length) {
            storage.GALAXY_IND += 1
            emits('hide-window')
            speedGalaxy()
            emits('set-new-audio')
            // setTimeout(() => emits('show-user-msg', 'Press space to move you spaceship'), 1100)
        }
    } else return;
}
const planetUrl = `/spacebar-clicker/assets/planets/planet_${gIndex}.png`
</script>

<template>
    <ModalBlock @closeWindow="$emit('hide-window')" :height="'fit-content'" >
        <template #header>
            <h3>Upgrade to {{ galaxy.name }}</h3>
        </template>
        <template #main >
            <p class="message">Please notice, you will lose everything you own in this galaxy: light years and aliens, but you will keep all your permanent upgrades.</p>
            <div class="row-wrap">
                <div class="img-wrap">
                    <p>{{ galaxy.name }}</p>
                    <img :src="planetUrl" alt="">
                </div>
                <div class="content-wrap">
                    <div class="award-wrap">
                        <p>By making a jump you will unlock:</p>
                        <div class="row">
                            <div class="coin-wrap">
                                <img height="50" src="/spacebar-clicker/assets/balls/ball_1.png" alt="" >
                                <p>{{ getPinkAward() }} </p>
                            </div>
                            <div v-if="alienAward">
                                <img height="50" :src="`/spacebar-clicker/assets/aliens/${alienAward.imgSrc}.png`" alt="" >
                                <p>{{ alienAward.name }} </p>
                            </div>                   
                            <div class="coin-wrap">
                                <img height="50" src="/spacebar-clicker/assets/balls/ball_9.png" alt="" >
                                <p>{{ getBlackAward() }} </p>
                            </div>
                        </div>
                    </div>
                    <div class="price-wrap col">
                        <p>Jump requirements</p>
                        <p><img class="coin-sm" :src="getCoinUrl()" alt="" >{{ stringNumber(galaxy.distance, true) }}</p>
                    </div>
                    <button class="action-btn" :class="{ 'aura-on': !isNotEnough }" :disabled="isNotEnough && !config.isDev" @click="upgradeGalaxy()">Jump to {{ galaxy.name }}</button>
                </div>
            </div>
        </template>
    </ModalBlock>
</template>

<style scoped>
.row-wrap {
    width: 100%;
    min-height: 300px;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-shadow: 3px 2px 7px 3px #ffffff3b;
    /* border: 2px solid black; */
    border-radius: 20px;
}

.row-wrap>div {
    flex: 1;
}

.content-wrap {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background: linear-gradient(90deg, black, rgb(255 255 255 / 19%));
}

.img-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: black;
    padding: 10px 5px;
}

.img-wrap p {
    color: white;
    border-bottom: 1px solid white;
    width: 90%;
    text-align: center;
    margin-bottom: 10px;
    font-size: 1.5rem;
}

.price-wrap {
    width: 100%;
    background-color: black;
    /* border: 2px solid black; */
    margin-top: 10px;
    padding: 5px;
}

.price-wrap p:first-child {
    color: red;
}

.price-wrap p {
    /* color: black; */
    font-size: 1.1rem;
    margin: 5px 0;
    color: white;
}

.award-wrap {
    position: relative;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    padding: 10px;
}

.award-wrap .row {
    justify-content: space-evenly;
}

.award-wrap p {
    color: white;
    font-size: 1.1rem;
    text-align: center;
}

.coin-wrap {
    position: relative;
    overflow: visible;
    background-color: black;
    padding: 10px;
    border-radius: 20px;
}

.coin-wrap img {
    height: 3.125rem;
}

.coin-wrap p {
    position: absolute;
    bottom: -5px;
    right: -5px;
    font-size: 1rem;
    font-weight: 600;
    /* background-color: white; */
    background-color: aqua;
    border-radius: 8px;
    padding: 3px;
    /* color: white; */
    color: black;
}

.message {
    /* background-color: rgb(241, 164, 164); */
    padding: 10px;
    border-radius: 20px;
    width: 100%;
    /* min-width: 300px; */
    text-align: center;
    font-size: 1rem;
    margin-bottom: 10px;
}

.action-btn {
    margin: 15px;
    font-size: 1.1rem;
    color: black;
    /* color: white; */
    /* background: linear-gradient(90deg, red, white); */
    background: linear-gradient(90deg, yellow, aqua);
    box-shadow: -1px 3px 3px 2px greenyellow;
}

.img-wrap img {
    width: 90%;
}

@media screen and (max-width:1200px) {
    .row-wrap {
        margin: 0 5px;
        width: calc(100% - 10px);
        box-sizing: content-box;
    }

    .row-wrap>div {
        flex: unset;
    }

    .img-wrap img {
        width: 80%;
    }
}

@media screen and (max-width:900px) {

    .message {
        margin-bottom: 0;
        padding: 5px;
    }

    .price-wrap {
        margin-top: 0;
    }

    .row-wrap {
        min-height: unset;
        height: fit-content;
    }

    .award-wrap {
        padding: 5px;
    }
}

@media screen and (max-height:500px) {
    .price-wrap.col {
        flex-direction: row;
        justify-content: space-evenly;
    }

}
</style>